import {Component, Input, OnInit, ViewChild, ChangeDetectorRef} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import {ToastrService} from "ngx-toastr";
import { ServiceRoleComponent } from "../../../components/pages/roles/components/service/service-role.component";
import {Bot} from "../../../models/bot";
import {Message} from "../../../models/message";
import {RoleStatusMessage} from "../../../models/status-message";
import {BotControllerService} from "../../../services/role-controller/bot-controller.service";
import {Store} from "../../../services/store.service";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {TutorialBase} from "../../../models/tutorial-base";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
    selector: "bot-detail",
    templateUrl: "./bot-detail.component.html",
    providers: [BotControllerService],
})
export class BotDetailComponent extends TranslatedBaseError implements OnInit {

    @Input() public bot: Bot;
    @Input() public determinantMapById: { [key: string]: string } = {};
    @Input() public serviceId: string;
    public botId: string;
    public serviceRoles: Bot[];

    public hideContent: boolean = true;
    public activeTab: string = "general";

    // For edit
    public message: Message;
    public roleStatusMessage: RoleStatusMessage;
    public messageType: string;
    public statusType: string;

    public resizeEdges = { bottom: false, right: false, top: false, left: true };
    public style: object = {};

    public isFormBuilderOpened = false;
    public isGeneralTabOpened = false;

    public showHistory: boolean = false;

    public mappingReady: boolean = false;

    @ViewChild(ServiceRoleComponent) public serviceRoleComponent: ServiceRoleComponent;

  constructor(public botController: BotControllerService, public determinantService: DeterminantControllerService,
              public store: Store,
              private route: ActivatedRoute, toastr: ToastrService,
              public translateService: TranslateService,
              private changeDetectorRef: ChangeDetectorRef) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.reloadRole();
    this.getServiceRolesList();
    this.getServiceDeterminantKeyName();
    this.store.state.common.sections.reset();
  }

  public notifyTabChange(tab) {
    if (tab === "bot-service" && !this.mappingReady) { return; }
    // send to localStorage
    localStorage.setItem("bot-details-tab", tab);
    this.activeTab = tab;
    this.serviceRoleComponent.togglePanel(this.activeTab === "bot-service");
  }

  public reloadRole() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.botId = params.botId;
      this.botController.getBot(this.botId).subscribe(
        (data) => this.uploadData(data),
      );
    });
  }

  public sortStatusesByNumber(statuses) {
    return statuses.sort((a, b) => {
      const textA = a.sortNumber;
      const textB = b.sortNumber;
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  public uploadData(bot: Bot) {
    this.bot = Object.assign(new Bot(), bot);
    this.bot.tutorials = Object.assign(new TutorialBase().tutorials, this.bot.tutorials);

    if (!this.bot.formSchema) {
      this.bot.formSchema = { components: [] };
    }
  }

  public getServiceRolesList() {
    this.botController.getServiceBots(this.serviceId).subscribe(
      (data) => this.serviceRoles = data,
    );
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public updatedRole() {
    this.serviceRoleComponent.resetMapping();
  }

  public saveTutorial(e) {
    if (e) {
      this.bot.tutorials.general = e;
      this.updateRole();
    }
  }

  public updateRole() {
    const successCb = (data: any) => {
      this.responseSuccessful("Saved successfully!");
    };
    const errorCb = (error: any) => {
      this.ngOnInit();
      return this.showErrorMessageWithTitle("Error during save/update of bot!", error);
    };
    return this.botController.saveBot(this.bot).subscribe(successCb, errorCb);
  }

  public closeEditDeterminant() {
    this.store.state.common.determinantSection.topLayer = null;
    this.store.state.common.determinantSection.determinant = {};
  }

  public closeSection() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = null;
    this.style = {};
  }

  public openStatusMessageEdit() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "statusMessageEdit";
  }

  public openMessageEdit() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "messageEdit";
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public openFormBuilder(openedOrClosed: any) {
    this.isFormBuilderOpened = openedOrClosed;
  }

  public openGeneralTab(openedOrClosed: any) {
    this.isGeneralTabOpened = openedOrClosed;
  }

  public openAddStatus() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "status";
  }

  public onMappingReady(event): void {
    this.mappingReady = event;
    this.changeDetectorRef.detectChanges();
    // check for selected tab
    if (localStorage.getItem("bot-details-tab") === "bot-service") {
      this.notifyTabChange("bot-service");
    }
  }

  public openHistory() {
    this.showHistory = true;
    this.serviceRoleComponent.togglePanel(false);
  }

  public closeHistory() {
    this.showHistory = false;
    this.serviceRoleComponent.togglePanel(true);
  }

  public changeForm(revisionNumber: string): void {
    if (revisionNumber) {
      this.botController.revertForm(this.bot.id, revisionNumber).subscribe((bot) => {
        if (bot) {
          this.responseSuccessful("Saved successfully!");
          this.reloadRole();
        }
      });
    }
  }

}
